var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBonus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11V16.25C18 18.1838 16.4338 19.75 14.5 19.75H7.5C5.56625 19.75 4 18.1838 4 16.25V11C4 10.5187 4.39375 10.125 4.875 10.125H6.59875C7.08 10.125 7.47375 10.5187 7.47375 11V13.7475C7.47375 14.395 7.8325 14.99 8.40125 15.2962C8.655 15.4362 8.935 15.5062 9.22375 15.5062C9.55625 15.5062 9.88875 15.41 10.1775 15.2175L11.0087 14.675L11.7788 15.1913C12.3125 15.55 12.995 15.5937 13.5638 15.2875C14.1413 14.9812 14.5 14.395 14.5 13.7387V11C14.5 10.5187 14.8938 10.125 15.375 10.125H17.125C17.6062 10.125 18 10.5187 18 11Z",
    fill: "#45a9ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 6.625V7.5C19.3125 8.4625 18.8487 9.25 17.5625 9.25H4.4375C3.09875 9.25 2.6875 8.4625 2.6875 7.5V6.625C2.6875 5.6625 3.09875 4.875 4.4375 4.875H17.5625C18.8487 4.875 19.3125 5.6625 19.3125 6.625Z",
    fill: "#45a9ef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6854 4.87477H5.85542C5.55792 4.55102 5.56667 4.05227 5.88167 3.73727L7.12417 2.49477C7.44792 2.17102 7.98167 2.17102 8.30542 2.49477L10.6854 4.87477Z",
    fill: "#45A9EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1366 4.87477H11.3066L13.6866 2.49477C14.0104 2.17102 14.5441 2.17102 14.8679 2.49477L16.1104 3.73727C16.4254 4.05227 16.4341 4.55102 16.1366 4.87477Z",
    fill: "#45A9EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7235 10.125C13.2048 10.125 13.5985 10.5187 13.5985 11V13.7387C13.5985 14.4387 12.8198 14.8587 12.2423 14.465L11.4548 13.94C11.166 13.7475 10.7898 13.7475 10.4923 13.94L9.66977 14.4825C9.09227 14.8675 8.32227 14.4475 8.32227 13.7562V11C8.32227 10.5187 8.71602 10.125 9.19727 10.125H12.7235Z",
    fill: "#45aa9ef"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBonus);
export default ForwardRef;